import { useEffect, useMemo, useRef } from 'react';
import { withRouter } from 'react-router';

const SCRIPT_SRC_BASE = 'https://app.termly.io';

function Termly({ autoBlock, masterConsentsOrigin, websiteUUID, location }) {
  const scriptSrc = useMemo(() => {
    const src = new URL(SCRIPT_SRC_BASE);
    src.pathname = `/resource-blocker/${websiteUUID}`;
    if (autoBlock) {
      src.searchParams.set('autoBlock', 'on');
    }
    if (masterConsentsOrigin) {
      src.searchParams.set('masterConsentsOrigin', masterConsentsOrigin);
    }
    return src.toString();
  }, [autoBlock, masterConsentsOrigin, websiteUUID]);

  const isScriptAdded = useRef(false);

  useEffect(() => {
    if (isScriptAdded.current) return;
    const script = document.createElement('script');
    script.src = scriptSrc;
    document.head.appendChild(script);
    isScriptAdded.current = true;
  }, [scriptSrc]);

  const pathname = location.pathname;
  const search = location.search;

  useEffect(() => {
    window.Termly && window.Termly.initialize();
  }, [pathname, search]);

  return null;
}

export default withRouter(Termly);



// WEBPACK FOOTER //
// ./src/components/termly.js